export const PAGE_SLUGS = {
  blog: "insights/blog",
  caseStudies: "insights/case-studies",
  webinars: "insights/webinars",
  events: "insights/events"
} as const;